import { ESearchFilters } from '@/constants/searchFilters';
import { TQueryParams } from '@/services/searchApiRequest';

import { camelToSnakeCase, normalizeSearchFilterKey } from './strings';

// Safelist(object) of only search related filters that should get sent to the api.
export const filterSafeQuery = (query: TQueryParams, toCamelCase = true) =>
  Object.keys(query)
    .filter(key => {
      const normalizedKey = normalizeSearchFilterKey(key);
      return Object.values(ESearchFilters).includes(normalizedKey as ESearchFilters);
    })
    .reduce((acc, key) => {
      const normalizedKey = normalizeSearchFilterKey(key);
      const finalKey = toCamelCase ? camelToSnakeCase(normalizedKey) : normalizedKey;
      return { ...acc, [finalKey]: query[key] };
    }, {});
